// Copyright (c) 2022 by Move Closer

import { VueConstructor } from 'vue'

import { IconsRegistry } from './icons.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function buildDSLRegistry (iconsRegistry: IconsRegistry): Record<string, VueConstructor> {
  return Object.entries(iconsRegistry).reduce(
    (acc, [iconName, iconDefinition]) => ({ ...acc, [iconName]: iconDefinition.component }),
    {}
  )
}
